export default "__VITE_PUBLIC_ASSET__9013c522__"